import { env } from '@/lib/env';

/**
 * Base URL for report downloads — routes through incidents API (/backend/api/reports/*).
 * Master agent is internal-only; reports are proxied via incidents API.
 *
 * Values are read from window.__ENV__ (injected at deploy time via config.js)
 * with fallback to process.env for local development.
 */
export function getMasterAgentApiBase() {
  const backend = (env('REACT_APP_BACKEND_URL') || '').replace(/\/$/, '');

  // Local dev — incidents API runs on :8001
  if (backend.includes('localhost') || backend.includes('127.0.0.1')) {
    return 'http://localhost:8001/api';
  }

  // Production — reports are served via incidents API through /backend/api
  if (backend.endsWith('/backend')) {
    return `${backend}/api`;
  }

  // Explicit override still supported
  const orchestrator = (env('REACT_APP_ORCHESTRATOR_URL') || '').trim().replace(/\/$/, '');
  if (orchestrator) return orchestrator;

  return '';
}

export function isInlineHtml(value) {
  if (!value || typeof value !== 'string') return false;
  const t = value.trim().toLowerCase();
  return t.startsWith('<!doctype') || t.startsWith('<html');
}

/** Rewrite SPA /reports/*.html links to master-agent GET /reports/{filename} via API GW. */
export function resolveReportFetchUrl(reportUrl) {
  if (!reportUrl || isInlineHtml(reportUrl)) return null;

  const filenameMatch = String(reportUrl).match(/\/reports\/([^/?#]+\.html)(?:[?#].*)?$/i);
  if (!filenameMatch) return reportUrl;

  const apiBase = getMasterAgentApiBase();
  if (!apiBase) return reportUrl;

  return `${apiBase}/reports/${encodeURIComponent(filenameMatch[1])}`;
}

/** CloudFront SPA fallback often returns index.html instead of the report file. */
export function isLikelySpaShellHtml(html) {
  if (!html || typeof html !== 'string') return false;
  const lower = html.toLowerCase();
  const hasRoot = lower.includes('id="root"') || lower.includes("id='root'");
  const hasBundle = lower.includes('/static/js/') || lower.includes('react');
  const looksLikeReport =
    lower.includes('sap_odata_report') ||
    lower.includes('sales order') ||
    (lower.includes('<table') && lower.includes('</table>'));
  return hasRoot && hasBundle && !looksLikeReport;
}